import React from "react";
import { Dialog, DialogContent, Stack, Typography } from "@mui/material";

import {ANSpriteLogo } from "@answersnow/pkg-theme";

export default function LoadingChangesDialog({ title, description, open, onClose }) {
  return (
    <Dialog maxWidth="xs" open={open} onClose={onClose}>
      <DialogContent>
        <Stack spacing={0}>
          <ANSpriteLogo />

          <Typography variant="body1" align="center" style={{ paddingBottom: 4 }}>
            {title}
          </Typography>

          <Typography variant="body2" align="center">
            {description}
          </Typography>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
